/<!--发票管理 -->
<template>
 <div class="container">
  <div class="home">
    <div class="tags">
      <div @click="childrenId=i" :class="{active:i === childrenId}" v-for="(item,i) in contentList" :key="i" class="subTag">{{item}}</div>
    </div>
     <div class="line"></div>
     <component
         style="width: 100%;"
         v-show="!showFlag"
         :is="componentsObj[childrenId]"
         :contentList="contentList"
         :page="page"
       ></component>
  </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import billingInformation from './components/billingInformation.vue'
import ticketList from './components/ticketList.vue'

  export default {
    components:{
      billingInformation,
      ticketList
    },
    data() {
      return {
          componentsObj: {
          },
          contentid:'',
          childrenId:0,
          showFlag: 0,
          contentList:[],
        page: {
        currentPage: 1,
      },
        multipleSelection: []
      }
    },
     computed: {
    ...mapGetters(["secondaryMenu", "dynamicMenu"]),
  },
  created() {
    if (this.dynamicMenu === "ON") {
      // 开启动态菜单，则二级菜单取store中的数据
      // return this.secondaryMenu[0].children;
      let temp = {};
      for (let j = 0; j < this.secondaryMenu.length; j++) {
        if ("发票管理" == this.secondaryMenu[j].menuName) {
          temp = this.secondaryMenu[j];
        }
      }
      for (let i = 0; i < temp.children.length; i++) {
        this.componentsObj[i] = temp.children[i].path;
        this.contentList[i] = temp.children[i].menuName;
      }
    }
  },
    showDetail(index, i) {
      this.showFlag = index;
      this.contentid = i;
    },
    methods: {
    onSubmit() {
      console.log('submit!');
    },
    toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      }
   }
  }
  
</script>

<style lang="less" scoped>

.container {
  background-color: #fff;
}

.home {
  padding-top: 14px;
}

h1 {
  color: #2E2F3C;
}

.tags {
  display: flex;
  margin-left: 41px;
  font-family: MicrosoftYaHei;
cursor: pointer;
  .subTag {
    padding: 0 20px;
    height: 36px;
    line-height: 36px;
    margin-right: 21px;
    text-align: center;
    color: var(--color-text);
    font-size: 14px;
  }
  .active {
    background: #EBF0FA;
    color: #1B5BBF;
    border-radius: 2px;
    border: 1px solid #D5DBE8;
  }
}

.line {
  margin:0 56px 0 41px;
  background-color: #d5dbe8;
  height: 1px;
  border:1px solid #dedbe8;
}
</style>
